export const FeatureApiTags = {
  FeatureFlags: 'FeatureFlags',
};
